import {
	AboutSection,
	ContactSection,
	DeliveriesSection,
	WelcomeSection,
	WorksSection
} from "components";
import { Helmet } from "react-helmet-async";
import {
	buildCanonicalUrl,
	buildOgImageAlt,
	defaultOgImage,
	homeDescription,
	homeTitle,
	keywords,
	siteName,
	siteUrl
} from "utils/seo";
import "./styles.scss";

function MainPage({ loading }: { loading: boolean }) {
	const canonicalUrl = buildCanonicalUrl("/");
	const ogImage = defaultOgImage;
	const ogImageAlt = buildOgImageAlt();
	const personJsonLd = {
		"@context": "https://schema.org",
		"@type": "Person",
		name: "Jacqueline Menassa",
		alternateName: ["Jacque Menassa", "Jacque", "Menassa"],
		jobTitle: "Estrategista de planejamento",
		description: homeDescription,
		url: siteUrl,
		image: ogImage,
		sameAs: ["https://www.linkedin.com/in/jacquelinemenassa/"],
		knowsAbout: [
			"Planejamento estrategico",
			"Estrategia de marca",
			"Publicidade",
			"Havaianas",
			"Natura"
		]
	};
	const websiteJsonLd = {
		"@context": "https://schema.org",
		"@type": "WebSite",
		name: siteName,
		url: siteUrl
	};
	const jsonLd = [personJsonLd, websiteJsonLd];

	return (
		<div className="main-page">
			<Helmet>
				<title>{homeTitle}</title>
				<meta name="description" content={homeDescription} />
				<meta name="keywords" content={keywords} />
				<meta name="robots" content="index,follow" />
				<meta
					name="googlebot"
					content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
				/>
				<link rel="canonical" href={canonicalUrl} />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content={siteName} />
				<meta property="og:locale" content="pt_BR" />
				<meta property="og:title" content={homeTitle} />
				<meta property="og:description" content={homeDescription} />
				<meta property="og:url" content={canonicalUrl} />
				<meta property="og:image" content={ogImage} />
				<meta property="og:image:alt" content={ogImageAlt} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={homeTitle} />
				<meta name="twitter:description" content={homeDescription} />
				<meta name="twitter:image" content={ogImage} />
				<script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
			</Helmet>
			<WelcomeSection loading={loading} />
			<AboutSection />
			<DeliveriesSection />
			<WorksSection />
			<ContactSection />
		</div>
	);
}

export default MainPage;
